import { useEffect, useRef, useState } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../tooltip/tooltip";

export function Truncate({
  children,
  text,
  maxLines = 1,
}: {
  children: React.ReactNode;
  text: React.ReactNode;
  maxLines?: number;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [showToolip, setShowTooltip] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);

  const compareSize = () => {
    if (ref.current) {
      const compareWidth = ref.current.scrollWidth > ref.current.clientWidth;
      const compareHeight = ref.current.scrollHeight > ref.current.clientHeight;
      setShowTooltip(compareWidth || compareHeight);
    }
  };

  // compare once and add resize listener on "componentDidMount"
  useEffect(() => {
    compareSize();
    window.addEventListener("resize", compareSize);

    return () => {
      window.removeEventListener("resize", compareSize);
    };
  }, []);

  return (
    <TooltipProvider>
      <Tooltip
        open={open}
        onOpenChange={(val) => {
          if (val && showToolip) {
            setOpen(true);
          } else {
            setOpen(false);
          }
        }}
      >
        <TooltipTrigger asChild>
          <div
            ref={ref}
            className="line-clamp-1 break-all"
            style={{ WebkitLineClamp: maxLines }}
          >
            {children}
          </div>
        </TooltipTrigger>
        <TooltipContent className="max-w-4xl">{text}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
